import React from "react";
import Tooltip, { TooltipProps as MuiTooltipProps } from "@mui/material/Tooltip";
import useCustomBranding from "hooks/useCustomBranding";

interface TooltipProps {
  title: string;
  children: any;
  showTooltip?: boolean; // Receive showTooltip from props
  toggleTooltip?: () => void;
  moveFromRight?: boolean | undefined;
  placement?: MuiTooltipProps["placement"];
}

const CustomToolTip: React.FC<TooltipProps> = ({
  title,
  children,
  showTooltip,
  toggleTooltip,
  moveFromRight,
  placement,
}) => {
  const { primaryColor } = useCustomBranding();
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      open={showTooltip}
      onOpen={toggleTooltip}
      onClose={toggleTooltip}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: primaryColor,
            marginRight: moveFromRight ? "22px" : "0px",
            "& .MuiTooltip-arrow": {
              color: primaryColor,
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomToolTip;
